import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./actualPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper";

export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  // If no data, create one empty row so table/columns are displayed
  const displayRows =
    rows && rows.length > 0
      ? rows
      : [
        {
          userid: "",
          workorder: "",
          DrAmount: 0,
          CrAmount: 0,
        },
      ];

  const grouped = groupByShop(displayRows);

  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(
        doc,
        shop,
        grouped[shop].rows,
        grouped[shop].total
      );
    });

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}

function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.userid ?? "";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          OB: 0,
          DEBIT: 0,
          CREDIT: 0,
          CB: 0,
        },
      };
    }

    groups[shop].rows.push(row);
    groups[shop].total.OB += Number(row.OB || 0);
    groups[shop].total.DEBIT += Number(row.DEBIT || 0);
    groups[shop].total.CREDIT += Number(row.CREDIT || 0);
    groups[shop].total.CB += Number(row.CB || 0);





    return groups;
  }, {});
}